window.bulldog = window.bulldog || {};

(function () {
  "use strict";

  bulldog.Jumplinks = function () {
    let sections = document.querySelectorAll("section[data-jumplink]");

    if (sections.length) {
      let jumplinkSection = document.querySelector(".LandingJumplinks .Container ul");
      let html = "";

      sections.forEach((el) => {
        var id = "section_" + Math.random().toString(16).slice(2);

        el.id = id;

        html += "<li>";
        html += '<a href="#' + id + '" title="">' + el.dataset.jumplink + "</a>";
        html += "</li>";
      });

      jumplinkSection.innerHTML = html;
    }
  };

  bulldog.Faq = function () {
    let answers = document.querySelectorAll(".LandingFaq .answer");

    if (answers.length) {
      answers.forEach((el) => {
        el.style.height = el.scrollHeight + 10 + "px";
      });
    }

    let questions = document.querySelectorAll(".LandingFaq .question");

    if (questions.length) {
      questions.forEach((el) => {
        el.addEventListener("click", function () {
          el.parentElement.classList.toggle("active");
        });
      });
    }
  };

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    const self = bulldog;

    bulldog.Jumplinks();
    bulldog.Faq();

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
